module.exports = __webpack_public_path__ + "static/media/Homepage_woman_tablet_570_560.24a4f041.jpg";